import type { ReactNode } from "react";

type EmptyStateProps = {
  title: string;
  description?: string;
  action?: ReactNode;
  icon?: string;
};

export default function EmptyState({ title, description, action, icon = "ri-inbox-line" }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-6 rounded-lg bg-background-100 border border-background-200">
      <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 mb-4">
        <i className={`${icon} text-2xl`}></i>
      </div>
      <h3 className="text-base font-semibold text-foreground-900">{title}</h3>
      {description && <p className="mt-2 text-sm text-foreground-500 max-w-md leading-relaxed">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}